import { GET_AUDIT_TRAIL_REQUEST, GET_AUDIT_TRAIL_SUCCESS, GET_AUDIT_TRAIL_ERROR } from './auditTrailActionTypes';

const initialState = {
  isLoading: false,
  trailRecords: [],
  count: 0,
  message: '',
};

export default function auditTrailReducer(state = initialState, action) {
  const { type, payload, isLoading, message } = action;
  switch (type) {
    case GET_AUDIT_TRAIL_REQUEST:
      return { ...state, isLoading };
    case GET_AUDIT_TRAIL_SUCCESS:
      return { ...state, isLoading, trailRecords: payload.data, count: payload.count };
    case GET_AUDIT_TRAIL_ERROR:
      return { ...state, isLoading, message };
    default:
      return state;
  }
}
